import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  // 현재 경로에서 언어코드 추출 (홈/게임 페이지용)
  const langMatch = location.pathname.match(/^\/([a-z]{2})(\/|$)/);
  const lang = langMatch ? langMatch[1] : (i18n.language || "en").split("-")[0];

  const gameDetail = /^\/[a-z]{2}\/(select-round|tier-list|quiz)\/[0-9a-f-]{36}(?:\/|$)/i.test(location.pathname);

  return (
<footer
  style={{
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    overflowX: "hidden",
    background: "#ffffff",
    borderTop: "3px solid #dde2ea",
    marginTop: 50,
    padding: "30px 0 20px 0",
    position: "relative",
    zIndex: 20,
    boxShadow: "0 4px 16px rgba(25,32,52,0.07)",
  }}
>
<div
  style={{
    width: "100%",
    maxWidth: 800,
    boxSizing: "border-box",
    margin: "0 auto",
    padding: "0 14px",
    textAlign: "center",
  }}
>
        {!gameDetail && (
        <div
          style={{
            color: "#202534",
            fontSize: 18,
            fontWeight: 600,
            marginBottom: 13,
            letterSpacing: 0.12,
            textShadow: "none",
            lineHeight: 1.5,
          }}
        >
          <Trans i18nKey="footer_description">
            Bracket game site <b>One Pick Game</b>. Create your own tournament
            bracket, enjoy fun matchups, and play with users around the world!
          </Trans>
        </div>
        )}

        {/* 제안 게시판: 영어 전용 루트 경로 */}
        <div style={{ marginBottom: 10 }}>
          <Link
            to={`/suggestions-board`}
            style={{
              color: "#202534",
              textDecoration: "underline",
              fontSize: 17,
              fontWeight: 700,
              margin: "0 12px",
            }}
          >
            {t("footer_suggestions_link", {
              defaultValue: "Ideal Type World Cup Suggestions",
            })}
          </Link>
        </div>

        {/* 약관/개인정보: 현재 언어의 전문 */}
        <div style={{ marginTop: 4 }}>
          <Link
            to={`/${lang}/terms-of-service`}
            style={{
              color: "#5542b8",
              textDecoration: "underline",
              fontSize: 17,
              fontWeight: 700,
              margin: "0 14px 0 0",
            }}
          >
            {t("terms_of_service", { defaultValue: "Terms of Service" })}
          </Link>
          <Link
            to={`/${lang}/privacy-policy`}
            style={{
              color: "#5542b8",
              textDecoration: "underline",
              fontSize: 17,
              fontWeight: 700,
              margin: "0 0 0 0",
            }}
          >
            {t("privacy_policy", { defaultValue: "Privacy Policy" })}
          </Link>
        </div>

        <div
          style={{
            marginTop: 14,
            color: "#5542b8",
            fontSize: 15,
            letterSpacing: 0.1,
            fontWeight: 600,
            opacity: 0.86,
            userSelect: "none",
          }}
        >
          &copy; {new Date().getFullYear()} One Pick Game
        </div>
      </div>
    </footer>
  );
}


